import React from 'react'
import { CFView, DefaultScreen, MobileScreen } from 'components'
import { contactbg, mobileContactbg } from 'images'
import RestaurantDetails from './RestaurantDetails'
import Hours from './Hours'
import Map from './Map'
import SocialMedia from './SocialMedia'
import DownloadApp from './DownloadApp'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView maxWidth="800px" w="100%" column>
          {/* <Map /> */}
          <CFView
            column
            w="100%"
            bg="white"
            style={{
              boxSizing: 'border-box',
              paddingLeft: '10%',
            }}
          >
            <Hours />
            <RestaurantDetails />
            {/* <SocialMedia /> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView maxWidth="1400px" w="100%" column center>
          {/* <Map /> */}
          <CFView w="100%" pv="50px" row mt="-2px" center bg="white">
            <CFView w="100%" column alignStart ml="25%">
              <Hours />
              <CFView column mt="50px">
                <RestaurantDetails />
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
